import React from 'react';
import styled from 'react-emotion';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import Separator from '@ublend-npm/aulaui-next-web/Separator';
import CircularProgress from 'material-ui/CircularProgress/CircularProgress';

export const ContentStyle = {
  padding: '0 24px',
};

export const ListSeparator = styled(Separator)`
  background-color: ${colors.blackAlpha(0.12)};
`;

export const Container = styled('div')`
  transition: background-color 0.3s;
  marginbottom: 0;
  cursor: pointer;
  &:hover {
    background-color: ${colors.designSystem.background.grey.hover};
    transition: background-color 0s;
  }
`;

export const SearchResultContainer = styled('div')`
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${theme.font.size.large}
  margin-top: 15px;
  margin-bottom: 15px;
`;

export const LoadingContainer = styled('div')`
  display: flex;
  width: 100%;
  min-height: 100%;
  align-items: flex-start;
  justify-content: space-around;
  padding-top: 75px;
`;

export const Loader = styled(() => (
  <CircularProgress color={colors.designSystem.purple70} thickness={2.5} />
))``;
